export default {
    ALL: 'ALL',
    IN_LISTS: 'IN_LISTS',
    NOT_IN_LISTS: 'NOT_IN_LISTS',
};
